export enum ProviderSyncStatus {
    Unset,
    Syncing,
    Synced,
    Error
}